// a function to handle errors for fetch
export const handleErrors = response => {
  if (!response.ok) {
    throw Error(response.statusText)
  }
  return response
}
